export default "__VITE_ASSET__b24e52bd__"